import LinkIcon from '@mui/icons-material/Link';
import React from 'react';
import useLinkPreview from '../../../../../features/Common/modules/Urls_Routing/modules/LinkPreview/useLinkPreview.js';
import { checkIsObjectEmpty } from '../../../../../utils/common/dataTypes/object.js';
import { styles } from './LinkPreview.styles.js';
import { getPreviewImage } from '../../../../../features/Offerings/modules/BrandedCommunity/components/LinkPreview/utils/LinkPreview.utils.js';

var LinkPreview = function (_a) {
    var url = _a.url, apiKey = _a.apiKey, errorLogger = _a.errorLogger;
    var _b = useLinkPreview({
        url: url,
        apiKey: apiKey,
        errorLogger: errorLogger,
    }), isLoading = _b.isLoading, previewData = _b.previewData;
    if (checkIsObjectEmpty(previewData) || isLoading)
        return null;
    var _c = previewData !== null && previewData !== void 0 ? previewData : {}, images = _c.images, favicon = _c.favicon, domain = _c.domain, title = _c.title, description = _c.description;
    var image = (images !== null && images !== void 0 ? images : [])[0];
    var previewImage = getPreviewImage(image);
    return (React.createElement("a", { className: styles.root, href: url, target: "_blank", rel: "noreferrer" },
        React.createElement("div", { className: styles.thumbnailContainer }, previewImage ? (React.createElement("img", { className: styles.thumbnail, src: previewImage, alt: "" })) : (React.createElement(LinkIcon, null))),
        React.createElement("div", { className: styles.dataContainer },
            React.createElement("div", null,
                title ? (React.createElement("div", { className: styles.title, title: title },
                    React.createElement("span", null, title))) : null,
                description ? (React.createElement("div", { className: styles.description, title: description },
                    React.createElement("span", null, description))) : null),
            favicon || domain ? (React.createElement("div", { className: styles.iconContainer, title: url },
                favicon ? React.createElement("img", { src: favicon, alt: "" }) : null,
                domain ? React.createElement("div", null, domain) : null)) : null)));
};

export { LinkPreview as default };
//# sourceMappingURL=LinkPreview.js.map
